import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppSftpService } from '../sftp.service';
import { AppToastManagerService } from '../../../shared/services/toast-manager.service';
import { SftpAccountCredentialsDto, SftpAccountResponseDto } from '@whetstoneeducation/hero-common';
import { SftpAccountCredentialsBase } from '../sftp-account-credentials.base';

@Component({
  selector: 'app-sftp-account-view',
  templateUrl: './sftp-account-view.template.html',
  styleUrls: ['./sftp-account-view.scss']
})
export class AppSftpAccountViewComponent extends SftpAccountCredentialsBase {
  public isLoading = false;
  public sftpAccount: SftpAccountResponseDto;
  public resetStart = false;
  public resetValidator: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AppSftpAccountViewComponent>,
    readonly sftpService: AppSftpService,
    private readonly toastService: AppToastManagerService
  ) {
    super(sftpService);
    this.sftpAccount = data;
  }

  public startAccountReset(): void {
    this.resetStart = true;
  }

  public async resetAccountPassword(): Promise<void> {
    if (this.resetValidator !== 'RESET') {
      return;
    }
    this.isLoading = true;
    try {
      this.accountCredentials = await this.sftpService.resetAccountPassword(
        this.sftpAccount.id
      );
      this.resetValidation();
      this.toastService.success('Password reset successfully.');
    } catch (error) {
      this.toastService.error('Error resetting password');
    } finally {
      this.isLoading = false;
    }
  }

  resetValidation(): void {
    this.resetStart = false;
    this.resetValidator = null;
  }

  closeDialog(): void {
    this.resetValidation();
    this.dialogRef.close();
  }
}
